import Card from "@/pages/components/card.vue";
import Default from "@/pages/inspection_reports/form-elements/default.vue";
import MeetbereikSwitchForm6 from "@/pages/inspection_reports/form-elements/meetbereik_switch_form_6.vue";
import Textarea from "@/pages/inspection_reports/form-elements/textarea.vue";
import TypeSwitchForm6 from "@/pages/inspection_reports/form-elements/type_switch_form_6.vue";
import YesNo from "@/pages/inspection_reports/form-elements/yes_no.vue";
import YesNoNvt from "@/pages/inspection_reports/form-elements/yes_no_nvt.vue";
import YesNoCalculateKValueForms from "@/pages/inspection_reports/form-elements/yes_no_calculate_k_values_forms.vue";
import YesNoCalculateCylindersForm9 from "@/pages/inspection_reports/form-elements/yes_no_calculate_cylinders_form_9.vue";
import YesNoCalculateForm2 from "@/pages/inspection_reports/form-elements/yes_no_calculate_form_2.vue";
import Number from "@/pages/inspection_reports/form-elements/number.vue";
import Select from "@/pages/inspection_reports/form-elements/select.vue";
import Afzuigeenheid from "@/pages/inspection_reports/form-elements/afzuigeenheid.vue";

export default {
	components: {
		Number,
		Select,
		Card,
		Default,
		MeetbereikSwitchForm6,
		Textarea,
		TypeSwitchForm6,
		YesNo,
		YesNoNvt,
		YesNoCalculateKValueForms,
		YesNoCalculateCylindersForm9,
		YesNoCalculateForm2,
		Afzuigeenheid,
	},
	props: ['group'],
}